/// <reference types="./SemVer.d.ts" />
export function parseSemVer(version) {
    const [major, minor, patch] = version.split('.').map((it) => Number.parseInt(it));
    return { major, minor, patch };
}
export function isSemVerEqualOrGreaterThan(version, minimum) {
    return (version.major > minimum.major ||
        (version.major === minimum.major &&
            (version.minor > minimum.minor ||
                (version.minor === minimum.minor && version.patch >= minimum.patch))));
}
//# sourceMappingURL=SemVer.js.map